import React from "react";
import '../../styles/common/select-with-visible-options.scss';
import IField from "../../models/view/common/IField";
import {FontIcon} from "./FontIcon";

//doing a generic here would make things much more difficult to wire, so allow for any.
type SelectedOptionChangedFunc = (value: any, label: string) => void; // eslint-disable-line

interface ISelectOption<T> {
  value: T;
  label: string;
}

interface ISelectWithVisibleOptionsProps<T> {
  options: ISelectOption<T>[];
  onChange: SelectedOptionChangedFunc;
  label?: string;
  value?: T;
  layout?: "horizontal" | "vertical";
  additionalClassName?: string;
}

export default function SelectWithVisibleOptions<T>({options, onChange, label, value, layout="vertical", additionalClassName }: ISelectWithVisibleOptionsProps<T>) {
  return (
    <div className={`select-with-visible-options ${layout} ${additionalClassName}`}>
      {createLabelEl(label)}
      <div className="select-options">
        {options.map( (option) => createSelectOption(option, onChange, value))}
      </div>
    </div>
  );
}

function createSelectOption<T>({value, label,}: ISelectOption<T>, onChange: SelectedOptionChangedFunc, selectedValue?: T){
  const selectedClass = value === selectedValue ? "selected" : "";
  const selectedCheckEl = value === selectedValue ? <span className="checkmark"><FontIcon icon={"icon-check"}/></span> : null;
  return <div
    key={label}
    className={`select-option ${selectedClass}`}
    tabIndex={0}
    onKeyPress={() => onChange(value, label)}
    onClick={() => onChange(value, label)}>
    <span className="label">{label}</span>{selectedCheckEl}</div>;
}

function createLabelEl(label?: string){
  if(!label){return;}
  return <span>{label}</span>;
}

export interface IFormFieldSelectWithVisibleOptionsProps<TValue> {
  optionsFormField: IField<ISelectOption<TValue>[]>;
  valueFormField: IField<TValue>;
  label?: string;
}

export function FormFieldSelectWithVisibleOptions<TValue>({optionsFormField, valueFormField, label}: IFormFieldSelectWithVisibleOptionsProps<TValue>){
  const options = optionsFormField.use().value;
  const value = valueFormField.use().value;
  return SelectWithVisibleOptions<TValue>({options, value, onChange: valueFormField.setValue, label});
}